import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

import {BusinessUnit, ReviewsResponse} from '../../types'
import {addReviewLinks} from '../../utils/addReviewLinks'

/**
 * Relative on purpose, so the call is same-origin in both apps. The client app
 * serves the route; checkout proxies it to the client app of its own
 * environment through a rewrite in next.config.js.
 */
const TRUSTPILOT_API_PATH = '/api/trustpilot'

export const trustpilotApi = createApi({
  reducerPath: 'trustpilotApi',
  baseQuery: fetchBaseQuery({baseUrl: TRUSTPILOT_API_PATH}),
  // SEO SRPs are CDN-cached for up to a month with their preloaded score, so
  // refetch entries older than a day, as the /details route's edge cache would.
  refetchOnMountOrArgChange: 24 * 60 * 60,
  endpoints: builder => ({
    getBusinessUnit: builder.query<BusinessUnit, void>({
      query: () => ({url: `/details`})
    }),
    getReviews: builder.query<
      ReviewsResponse,
      {
        stars?: number[]
        language: string
        perPage?: number
        page?: number
        orderBy?: string
      }
    >({
      query: ({
        stars = [4, 5],
        language,
        perPage,
        page,
        orderBy = 'createdat.desc'
      }) => {
        const [validLanguageCode] = language?.split('-') ?? []
        return {
          url: `/reviews`,
          params: {stars, language: validLanguageCode, perPage, page, orderBy}
        }
      },
      transformResponse: addReviewLinks
    })
  })
})

export const {useGetBusinessUnitQuery, useGetReviewsQuery} = trustpilotApi
